import React from "react";
import "./SourceCard.css";

const SourceCard = ({ logo, heading, about, link }) => {
  return (
    <div className="source-card">
      {logo && (
        <div className="source-logo">
          <img src={logo} alt={`${heading} logo`} />
        </div>
      )}
      <div className="source-content">
        <h3 className="source-heading">{heading}</h3>
        <p className="source-about">{about}</p>
        {link && (
          <a
            href={link}
            className="source-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit Website
          </a>
        )}
      </div>
    </div>
  );
};

export default SourceCard;
